'use client';
import React, { useEffect } from 'react';

// if smooth scroll is enabled on html in css, it smooth scrolls in between pages
// might be fine, but this allows only for smooth scrolling on hash changes
// https://github.com/vercel/next.js/issues/44625#issuecomment-1405018008
// like button on contact page
export const SmoothScroll = ({ children }: { children: React.ReactNode }) => {
    useEffect(() => {
        const html = document.documentElement;

        const handleClick = (e: MouseEvent) => {
            const getAnchorEl = (target: HTMLElement | null): HTMLAnchorElement | null => {
                if (!target) return null;
                if (target.tagName === 'A') return e.target as HTMLAnchorElement;
                if (target.parentElement?.tagName === 'A') return target.parentElement as HTMLAnchorElement;
                return null;
            };

            const el = getAnchorEl(e.target as HTMLElement);

            if (!el) return;
            const hash = el.hash.slice(1);
            if (!hash) return;
            html.style.setProperty('scroll-behavior', 'smooth', 'important');
            setTimeout(() => {
                html.style.removeProperty('scroll-behavior');
            }, 3000);
        };

        document.addEventListener('click', handleClick, false);
        return () => document.removeEventListener('click', handleClick);
    }, []);

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
};

export default SmoothScroll;
